import React, { Component } from 'react';
import { withRouter } from '../withRouter';
import './InventoryManagement/css/inventoryManagement.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';
import { SelectSublocation } from './InventoryManagement/componentChildren/SelectSublocation';
import { SublocationSearch} from './InventoryManagement/componentChildren/SublocationSearch';
import { SublocationContents } from './InventoryManagement/componentChildren/SublocationContents';
import { SublocationItemInfo } from './InventoryManagement/componentChildren/SublocationItemInfo';
import { ItemLookupSublocationManagement } from './InventoryManagement/componentChildren/ItemLookupSublocationManagement';
import { ItemSearch } from './InventoryManagement/componentChildren/ItemSearch';

class ManageSublocations extends Component {
    constructor(props) {
        super(props);
        const sublocationLinkInfo = this.props.location?.state?.sublocationInfo;
        this.state = {
            view: "selectSublocation",
            sublocationActionHeader: "",
            sublocationButton: "",
            sublocationMethod: "",
            sublocationContents: [],
            sublocationSearchResults: [],
            sublocationId: this.props.location?.state?.sublocationInfo?.id,
            newSublocation: null,
            sublocationName: "",
            sublocationInput: "",
            sublocationImageURL: "",
            stkInfoId: null,
            maxCapacity: null,
            preferred: null,
            itemId: null,
            itemName: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: sublocationLinkInfo ? true : false
        };
        this.refreshState = this.refreshState.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.findSublocation = this.findSublocation.bind(this);
        this.findSublocationCallback = this.findSublocationCallback.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.selectSublocation = this.selectSublocation.bind(this);
        this.selectNewSublocation = this.selectNewSublocation.bind(this);
        this.cancelSublocationUpdate = this.cancelSublocationUpdate.bind(this);
        this.getAdditionalStockInfo = this.getAdditionalStockInfo.bind(this);
        this.getSublocationContents = this.getSublocationContents.bind(this);
        this.getSublocationContentsCallback = this.getSublocationContentsCallback.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.viewImage = this.viewImage.bind(this);
        this.viewItemInfo = this.viewItemInfo.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.removeItemCallback = this.removeItemCallback.bind(this);
        this.cancelAddItem = this.cancelAddItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.lookupItemInfo = this.lookupItemInfo.bind(this);
        this.lookupItemInfoCallback = this.lookupItemInfoCallback.bind(this);
        this.addItemToSublocation = this.addItemToSublocation.bind(this);
        this.moveItem = this.moveItem.bind(this);
        this.updateSublocation = this.updateSublocation.bind(this);
        this.updateSublocationCallback = this.updateSublocationCallback.bind(this);
        
        if (sublocationLinkInfo) {
            this.selectSublocation(sublocationLinkInfo);
        }
    }

    componentDidMount() {
        document.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var sublocationInput = document.getElementById('subloc-input');
                var itemLookupInput = document.getElementById('item-lookup-submit');
                if (sublocationInput) {
                    var submitButton = document.getElementById('sublocation-search-submit');
                    submitButton.click();
                }
                else if (itemLookupInput) {
                    itemLookupInput.click();
                }
            }
        });
    }

    componentWillUnmount() {
        document.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var sublocationInput = document.getElementById('subloc-input');
                var itemLookupInput = document.getElementById('item-lookup-submit');
                if (sublocationInput) {
                    var submitButton = document.getElementById('sublocation-search-submit');
                    submitButton.click();
                }
                else if (itemLookupInput) {
                    itemLookupInput.click();
                }
            }
        });
    }

    refreshState() {
        this.setState({
            view: "selectSublocation",
            sublocationActionHeader: "",
            sublocationButton: "",
            sublocationMethod: "",
            sublocationContents: [],
            sublocationSearchResults: [],
            sublocationId: null,
            newSublocation: null,
            sublocationName: "",
            sublocationInput: "",
            sublocationImageURL: "",
            stkInfoId: null,
            maxCapacity: null,
            preferred: null,
            itemId: null,
            itemName: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
        this.focusOnInput();
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    focusOnInput() {
        if (!this.state.showDialog && (this.state.sublocationContents.length == 0 || this.state.view == "sublocationSearch"))  {
            var inputField = document.getElementById('subloc-input');
            inputField.focus();
        }
    }

    updateInputValue(field, inputValue) {
        this.setState({
            [field]: inputValue
        });
    }

    selectSublocation(sublocationInfo) {
        this.setState({
            sublocationId: sublocationInfo.id,
            sublocationName: sublocationInfo.name,
            sublocationImageURL: sublocationInfo.imageURL
        }) 
        this.getSublocationContents();
    }

    selectNewSublocation(sublocationId, sublocationName) {
        this.setState({
            newSublocation: sublocationId,
            newSublocationName: sublocationName
        });
    }

    cancelSublocationUpdate() {
        this.setState({
            sublocationSearchResults: [],
            newSublocation: null,
            sublocationActionHeader: null,
            sublocationMethod: null,
            sublocationButton: null,
            view: "sublocationContents"
        });
    }

    getAdditionalStockInfo() {
        let maxCapacity = 0;
        let preferred = false;
        //Prompt the user for the max capacity and preferred status of the sublocation
        //Max capacity is a number, preferred is a boolean
        /*do {
            maxCapacity = prompt("Enter the maximum capacity of the sublocation", 0);
        } while (isNaN(maxCapacity) || maxCapacity < 0 || maxCapacity > 100000)
        let preferredResponse;
        do {
            preferredResponse = prompt("Is this a preferred sublocation? (y/n)").toLowerCase();
        } while (preferredResponse !== "y" && preferredResponse !== "n");

        preferred = preferredResponse === "y";*/
        this.setState({
            maxCapacity: maxCapacity,
            preferred: preferred
        });
    }

    getSublocationContents() {
        this.startLoading();
        setTimeout(() => {
            this.getSublocationContentsCallback();
        }, 1000);
    }

    getSublocationContentsCallback() {
        const postBody = {
            getSublocationContents: true,
            sublocationId: this.state.sublocationId
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (getSublocationContentsResult) => {
                console.log(getSublocationContentsResult);
                if (getSublocationContentsResult.success) {
                    this.setState({
                        view: "sublocationContents",
                        sublocationContents: getSublocationContentsResult.sublocationInfo
                    });
                }
                else {
                    this.setState({
                        userInput: "",
                        showDialog: true,
                        dialogTitle: "There was an error with this sublocation",
                        dialogContent: getSublocationContentsResult.message,
                        isErrorMessage: true
                    })
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
        });


    }

    findSublocation() {
        const searchString = this.state.sublocationInput;
        if (!searchString) {
            return;
        }
        this.startLoading();
        setTimeout(() => {
            this.findSublocationCallback();
        });
    }

    findSublocationCallback() {
        const postBody = {
            findSublocation: true,
            searchString: this.state.sublocationInput
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (findSublocationResults) => {
                console.log(findSublocationResults);
                if (findSublocationResults.sublocationInfo.length > 0) {
                    let newSublocation;
                    if (findSublocationResults.sublocationInfo.length == 1) {
                        this.selectSublocation(findSublocationResults.sublocationInfo[0]);
                    }
                    else {
                        this.setState({
                            sublocationSearchResults: findSublocationResults.sublocationInfo,
                            newSublocation: newSublocation,
                            sublocationInput: "",
                            sublocationId: null,
                            view: this.state.view != "sublocationSearch" ? "selectSublocation" : "sublocationSearch"
                        });
                    }
                }
                else {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Sublocation Not Found",
                        dialogContent: "Sublocation not found. Please try again with a different search term.",
                        isErrorMessage: true,
                        sublocationInput: ""
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    viewImage(event, itemName, imageUrl) {
        event.preventDefault();
        this.setState({
            showDialog: true,
            dialogTitle: itemName,
            dialogContent: <img src={imageUrl} alt={itemName} style={{ width: '300px', height: '300px', objectFit: 'cover' }} />,
            dialogFullScreen: true
        })
    }

    viewItemInfo(event,itemInfo) {
        event.preventDefault();
        console.log("ITEM INFO", itemInfo);
        this.setState({
            showDialog: true,
            dialogTitle: itemInfo.name,
            dialogContent: <SublocationItemInfo
                itemInfo={itemInfo}
                removeItem={this.removeItem}
                moveItem={this.moveItem}
            />,
            dialogFullScreen: false
        });
    }

    removeItem(itemId, stkInfoId) {
        if (window.confirm("Are you sure you want to remove this item?")) {
            this.setState({
                loading: true,
                showDialog: false,
                dialogContent: "",
                dialogTitle: ""
            });
            setTimeout(() => {
                this.removeItemCallback(itemId, stkInfoId);
            });
        } 
    }

    removeItemCallback(itemId, stkInfoId) {
        var postBody = {
            stkInfoId: stkInfoId,
            itemId: itemId,
            sublocationId: this.state.sublocationId,
            removeSublocation: true,
            getContents: true
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (removeItemResponse) => {
                console.log(removeItemResponse);
                if (removeItemResponse.success) {
                    this.setState({
                        sublocationContents: removeItemResponse.sublocationInfo
                    });
                }
                else {
                    alert("Item removal failed. Please try again");
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    cancelAddItem() {
        this.setState({
            userInput: "",
            view: "sublocationContents"
        });
     }

    addItem() {
        this.setState({
            userInput: "",
            view: "itemLookup"
        });
    }

    lookupItemInfo() {
        this.setState({
            loading: true
        });
        setTimeout(() => { this.lookupItemInfoCallback() });
    }

    async lookupItemInfoCallback() {
        await this.props.makeRESTCall(
            'byuinventorymanagement?itemIdentifier=' + this.state.userInput,
            'get',
            null,
            (itemLookupInfo) => {
                console.log(itemLookupInfo);
                if (itemLookupInfo.foundItem) {
                    const itemId = itemLookupInfo.itemId;
                    const itemName = itemLookupInfo.itemName;
                    this.addItemToSublocation(itemId, itemName);
                }
                else {
                    this.setState({
                        userInput: "",
                        showDialog: true,
                        dialogTitle: "Item Not Found",
                        dialogContent: "Item not found. Please try again with a different UPC.",
                        isErrorMessage: true,
                        loading: false
                    })
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true,
                    loading: false
                });
            },
            () => {

            }
        );
    }

    addItemToSublocation(itemId, itemName) {
        this.getAdditionalStockInfo();
        var postBody = {
            sublocationId: this.state.sublocationId,
            itemId: itemId,
            addItemToSublocation: true,
            maxCapacity: this.state.maxCapacity,
            preferred: this.state.preferred
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (addItemToSublocationResponse) => {
                console.log(addItemToSublocationResponse);
                if (addItemToSublocationResponse.success) {
                    this.setState({
                        sublocationContents: addItemToSublocationResponse.sublocationContents,
                        view: "sublocationContents"
                    });
                }
                else {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Error Adding Item",
                        dialogContent: addItemToSublocationResponse.message,
                        isErrorMessage: true
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false,
                    maxCapacity: null,
                    preferred: null
                });
            }
        );
    }

    moveItem(stkInfoId, itemId, itemName) {
        this.setState({
            sublocationActionHeader: (
                <>
                    <b>MOVE: {itemName}</b>
                    <br />
                    <b>FROM: {this.state.sublocationName}</b>
                    <br />
                </>
            ),
            itemName: itemName,
            stkInfoId: stkInfoId,
            itemId: itemId,
            sublocationMethod: "moveSublocation",
            view: "sublocationSearch",
            sublocationSearchResults: [],
            sublocationInput: "",
            showDialog: false,
            dialogContent: "",
            dialogTitle: "",
            sublocationButton: <button onClick={() => { this.updateSublocation() }}>Move Here</button>
        })
    }

    updateSublocation() {
        this.setState({
            loading: true
        });
        setTimeout(() => { this.updateSublocationCallback()});
    }

    updateSublocationCallback() {
        this.getAdditionalStockInfo();
        var postBody = {
            stkInfoId: this.state.stkInfoId,
            sublocationId: this.state.newSublocation,
            itemId: this.state.itemId,
            getContents: true,
            [this.state.sublocationMethod]: true,
            maxCapacity: this.state.maxCapacity,
            preferred: this.state.preferred
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (updateSublocationResponse) => {
                console.log(updateSublocationResponse);
                if (updateSublocationResponse.success) {
                    this.setState({
                        sublocationContents: updateSublocationResponse.sublocationInfo,
                        sublocationActionHeader: null,
                        sublocationMethod: null,
                        sublocationButton: null,
                        sublocationSearchResults: [],
                        view: "sublocationContents"
                    });
                }
                else {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Error Updating Sublocation",
                        dialogContent: updateSublocationResponse.message,
                        isErrorMessage: true
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false,
                    maxCapacity: null,
                    preferred: null
                });
            }
        );
    }


    /*
        Search for a Sublocation
        See list of items in that sublocation
        Have the option to Add and item, Movie an item, or Remove an item
        We want the items to have a picture, and see if we can have them upload a picture
    */

    render() {
        return (
            <div className="itemLookup">
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                {
                    this.state.view == "selectSublocation"
                    &&
                    <>
                        <div className="page-title">
                            <h3>Manage Sublocations</h3>
                            <br />
                        </div>
                        <SublocationSearch
                            updateInputValue={this.updateInputValue}
                            focusOnInput={this.focusOnInput}
                            sublocationInput={this.state.sublocationInput}
                            findSublocation={this.findSublocation}
                        />
                        {
                            this.state.sublocationSearchResults.length > 0 &&
                            <>

                                <SelectSublocation
                                    sublocationSearchResults={this.state.sublocationSearchResults}
                                    selectSublocation={this.selectSublocation}
                                    sublocationId={this.state.sublocationId}
                                    useCheckboxes={false}
                                />
                            </>  
                        }
                    </>
                }
                {
                    this.state.view == "sublocationContents"
                    &&
                    <>
                        <div className="item-lookup-buttons">
                            <button onClick={() => {this.addItem()}} >Add Item</button>
                        </div>
                        <SublocationSearch
                            updateInputValue={this.updateInputValue}
                            focusOnInput={this.focusOnInput}
                            sublocationInput={this.state.sublocationInput}
                            findSublocation={this.findSublocation}
                        />
                        <SublocationContents
                            sublocationId={this.state.sublocationId}
                            sublocationName={this.state.sublocationName}
                            sublocationImageURL={this.state.sublocationImageURL}
                            sublocationContents={this.state.sublocationContents}
                            viewImage={this.viewImage}
                            viewItemInfo={this.viewItemInfo}
                        />
                    </>
                }
                {
                    this.state.view == "sublocationSearch"
                    &&
                    <>
                        <ItemLookupSublocationManagement
                            sublocationSearchResults={this.state.sublocationSearchResults}
                            updateInputValue={this.updateInputValue}
                            sublocationInput={this.state.sublocationInput}
                            focusOnInput={this.focusOnInput}
                            findSublocation={this.findSublocation}
                            selectSublocation={this.selectNewSublocation}
                            cancelSublocationUpdate={this.cancelSublocationUpdate}
                            sublocationButton={this.state.sublocationButton}
                            itemName={this.state.itemName}
                            sublocationActionHeader={this.state.sublocationActionHeader}
                            newSublocation={this.state.newSublocation}
                        />
                    </>
                }
                {
                    this.state.view == "itemLookup"
                    &&
                    <ItemSearch
                        userInput={this.state.userInput}
                        updateInputValue={this.updateInputValue}
                        focusOnInput={this.focusOnInput}
                        lookupItemInfo={this.lookupItemInfo}
                        sublocationName={this.state.sublocationName}
                        cancelAddItem={this.cancelAddItem}
                        addingItem={true}
                    />
                }
            </div>
        );
    }
}

export default withRouter(ManageSublocations);
